import React from 'react';
import { Container, Col, Row } from 'reactstrap';
import PurchasesTable from './components/PurchasesTable';

// import NewItemsTable from './components/NewItemsTable';

const PurchaseManagement = () => (
  <Container>
    <Row>
      <Col md={12}>
        <h5 className="page-title">Purchases Management</h5>
      </Col>
    </Row>
    <Row>
      <Col md={12}>
        <PurchasesTable />
      </Col>
    </Row>
  </Container>
);

export default PurchaseManagement;
